module.exports = ".panel {\r\n    max-width: 380px;\r\n    margin: auto;\r\n    margin-top: 100px;\r\n}\r\n  \r\ninput {\r\n    margin-top: 10px; \r\n}\r\n  \r\nbutton {\r\n    margin-top: 30px;\r\n    font-weight: bold;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main